<template>
  <div
    class="flex items-center justify-center min-h-screen bg-white dark:bg-black p-4 md:p-8 lg:p-16"
  >
    <div class="bg-white dark:bg-black w-full max-w-md">
      <div class="space-y-8">
        <div class="space-y-4 mb-8">
          <div class="flex items-center justify-center space-x-2 mb-8 relative">
            <router-link to="/home" class="flex items-center">
              <img src="Logo-PG.svg" alt="Logo" class="h-10 w-auto" />
            </router-link>
          </div>
          <h2
            class="text-3xl font-bold mb-6 text-left text-bodyText dark:text-white"
          >
            Forgot Password
          </h2>
          <p class="text-[14px] text-grayDark dark:text-gray-400">
            Enter your email address below and we’ll send you a code to log in
            and reset your password
          </p>
        </div>
        <form @submit.prevent="forgotPassword">
          <div class="mb-4">
            <label
              class="block text-sm font-medium text-gray-700 dark:text-gray-300"
              >Email</label
            >
            <input
              v-model="email"
              type="email"
              placeholder="Enter your email address"
              class="mt-1 block w-full px-3 py-2 border border-gray-300 dark:border-gray-800 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm bg-[#F6F8F9] dark:bg-[#1A1A1A] dark:text-white"
              required
              :disabled="isLoading"
            />
          </div>
          <button
            type="submit"
            class="w-full py-2 px-4 bg-primaryDarkBg hover:bg-primaryDark text-white font-bold rounded disabled:opacity-50 disabled:cursor-not-allowed"
            :disabled="isLoading"
          >
            <span v-if="!isLoading">Send Code</span>
            <span v-else>Sending...</span>
          </button>
        </form>
      </div>

      <div>
        <hr
          class="w-full border-t-[1px] border-grayLight dark:border-gray-800 mb-6"
        />
        <p
          class="mt-6 text-primaryDark dark:text-white flex justify-between items-center"
        >
          Remember your password?
          <router-link
            to="/login"
            class="text-primaryDark dark:text-blue-400 hover:underline px-3 py-3 bg-[#EEEEEE] dark:bg-[#1A1A1A] rounded-md transition-colors"
            >Log In</router-link
          >
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import apiClient from "@/axios";

export default {
  name: "ForgotPasswordComponent",
  data() {
    return {
      email: "",
      isLoading: false,
    };
  },
  methods: {
    async forgotPassword() {
      if (!this.email) {
        this.$toast.error(
          "Validation Error",
          "Please enter your email address",
        );
        return;
      }

      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(this.email)) {
        this.$toast.error(
          "Validation Error",
          "Please enter a valid email address",
        );
        return;
      }

      this.isLoading = true;

      try {
        const response = await apiClient.post("/web/forgot_password", {
          email: this.email,
        });

        if (response.data.status_code === 200) {
          this.$toast.success("Code Sent", response.data.message);
          this.goToResetPassword();
        }
      } catch (error) {
        console.error("Error sending forgot password request:", error);

        const errorMsg =
          error.response?.data?.detail ||
          error.response?.data?.message ||
          "An error occurred. Please try again later.";
        this.$toast.error("Request Failed", errorMsg);
      } finally {
        this.isLoading = false;
      }
    },
    goToResetPassword() {
      this.$router.push({
        name: "ResetPassword",
        query: { email: this.email },
      });
    },
  },
};
</script>

<style scoped>
/* Autofill styling for dark mode */
.dark input:-webkit-autofill,
.dark input:-webkit-autofill:hover,
.dark input:-webkit-autofill:focus,
.dark textarea:-webkit-autofill,
.dark textarea:-webkit-autofill:hover,
.dark textarea:-webkit-autofill:focus,
.dark select:-webkit-autofill,
.dark select:-webkit-autofill:hover,
.dark select:-webkit-autofill:focus {
  -webkit-text-fill-color: white !important;
  -webkit-box-shadow: 0 0 0px 1000px #0a0a0a inset !important;
  transition: background-color 5000s ease-in-out 0s;
}
</style>
